import { twApi } from '../api';

import {
  Disclaimer,
  GetDisclaimersParams,
  CreateDisclaimerParams,
  UpdateDisclaimerParams,
  SearchDisclaimersParams
} from './disclaimer.model';

const disclaimerApi = twApi.injectEndpoints({
  endpoints: (builder) => ({
    getDisclaimer: builder.query<Disclaimer, GetDisclaimersParams>({
      query: ({ division_id, document_type }) => ({
        url: '/disclaimers',
        method: 'GET',
        params: { division_id, document_type }
      }),
      transformResponse: (response: { data: Disclaimer }) => response.data,
    }),
    searchDisclaimers: builder.query<Disclaimer[], SearchDisclaimersParams>({
      query: ({ division_id, document_types }) => ({
        url: '/disclaimers/search',
        method: 'POST',
        body: { division_id, document_types }
      }),
      transformResponse: (response: { data: Disclaimer[] }) => response.data,
      providesTags: () => [{ type: 'Disclaimer', id: 'DISCLAIMERS_LIST' }]
    }),
    createDisclaimer: builder.mutation<Disclaimer, CreateDisclaimerParams>({
      query: (body) => ({
        url: '/disclaimers',
        method: 'PUT',
        body
      }),
      transformResponse: (response: { data: Disclaimer }) => response.data,
      invalidatesTags: [{ type: 'Disclaimer', id: 'DISCLAIMERS_LIST' }]
    }),
    updateDisclaimer: builder.mutation<Disclaimer, UpdateDisclaimerParams>({
      query: ({ id, ...body }) => {
        return {
          url: `/disclaimers/${id}`,
          method: 'PATCH',
          body
        };
      },
      transformResponse: (response: { data: Disclaimer }) => response.data,
      invalidatesTags: [{ type: 'Disclaimer', id: 'DISCLAIMERS_LIST' }]
    })
  })
});

export const { useGetDisclaimerQuery, useSearchDisclaimersQuery, useCreateDisclaimerMutation, useUpdateDisclaimerMutation } =
  disclaimerApi;
